import React, { useCallback, useEffect, useState } from 'react'
import Footer from '../components/Footer'
import Navbar from '../components/Home/Navbar'
import { ItemSkeleton } from '../components/Widgets/CustomSkeleton'
import ProductCard from '../components/Widgets/ProductCard'
import ScrollUpButton from '../components/Widgets/ScrollUpButton'
import { findAll } from '../services/store'
import { blogNavLinks } from '../utilities/links'
import { dummyStore } from '../utilities/store'

const Store = () => {
	const [store, setStore] = useState(dummyStore)
	const [isLoading, setIsLoading] = useState(true);

	const getStore = useCallback(async () => {
		setIsLoading(true);
		const res = await findAll()
		if (res[0]) {
			setStore(res);
			setIsLoading(false);
		} else {
			setTimeout(() => {
				getStore();
			}, 2000);
		}
	}, [],)

	useEffect(() => {
		getStore()
	}, [getStore])
	return (
		<>
			<Navbar links={blogNavLinks} />
			<section id="home" className="h-[50vh] bg-cover relative bg-[0px_-10px] bg-[url('https://images.unsplash.com/photo-1423666639041-f56000c27a9a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1474&q=80')]">
				<div className='inset-0 absolute bg-[#161c2dbf] opacity-90'></div>
				<div className='flex h-full flex-col relative'>
					<div className='m-auto max-w-2xl md:max-w-[60rem] pt-20 app-x'>
						<h3 className='font-serif leading-snug text-center font-extrabold text-white text-4xl md:text-5xl'>
							Best collections of items
						</h3>
					</div>
				</div>
			</section>
			<div className='py-10 app-x dark:bg-slate-900'>
				<div className="grid gap-10 grid-cols-[repeat(auto-fill,_minmax(200px,_1fr))] md:grid-cols-[repeat(auto-fill,_minmax(250px,_1fr))]">
					{store.map((each, i) => (
						isLoading ? <ItemSkeleton key={i} /> :
							<ProductCard key={i} data={each} />
					))}
				</div>
			</div>
			<Footer />
			<ScrollUpButton />
		</>
	)
}

export default Store